import React, { Component } from 'react';

class RadioForm extends Component {

    state= {
        //data:{},

        id:"",
        text: "",
        width:"",
        offset:"",
        defaultValue: "",
        hidden:"",
        values: [],
        required: false,
        align: "",
        selectValue: [],
        showLabel: true,
        rowIndex: -1
    }

    counter = 0;
    getCounter = ()=>{
        return this.counter++
    }

    //initial state
    constructor(props){
        super(props)
        //this.selectInput = React.createRef();

        //this.state.data= props.data;

        this.state.id= props.data.domain;
        this.state.text = props.data.text;
        this.state.width= props.data.width;
        this.state.offset= props.data.offset;
        this.state.defaultValue = props.data.defaultValue;
        this.state.hidden = props.data.hidden;
        if(this.state.defaultValue === '' || this.state.defaultValue === 0){
            //this.state.defaultValue = this.getDataKey(props.data.values[0]);
            this.state.defaultValue = '';
        }
        this.state.values= props.data.values;
        this.state.required= props.required;
        this.state.align = props.data.align;
        this.state.showLabel= props.showLabel;
        this.state.rowIndex = props.rowIndex;

        props.addToResult(this.state.id, this.state.defaultValue, this.state.rowIndex);
    }

    handleChange = (selectName, e) => {
        this.props.addToResult(selectName, e.target.value, this.state.rowIndex);
    };

    getDataKey = (value) => {
        var tags= Object.keys(value);
        var tagKey= tags[0];         
        return value[tagKey];
    }

    getDataValue = (value) => {
        var tags= Object.keys(value);
        var tagValue= tags[1];          
        return value[tagValue];
    }
        
    getWidthClass(width) {
        switch (width) {
            case 0:
                return "";
            case 1:
                return "col-1";
            case 2:
                return "col-2";
            case 3:
                return "col-3";
            case 4:
                return "col-4";
            case 5:
                return "col-5";
            case 6:
                return "col-6";
            case 7:
                return "col-7";
            case 8:
                return "col-8";
            case 9:
                return "col-9";
            case 10:
                return "col-10";
            case 11:
                return "col-11";
            case 12:
                return "col-12";
            default:
                //return <Input addToResult={this.addToResult} formJson={item} />
                return "";
        }                
    }

    getOffsetClass(offset) {
        switch (offset) {
            case 0:
                return "";
            case 1:
                return "offset-1";
            case 2:
                return "offset-2";
            case 3:
                return "offset-3";
            case 4:
                return "offset-4";
            case 5:
                return "offset-5";
            case 6:
                return "offset-6";
            case 7:
                return "offset-7";
            case 8:
                return "offset-8";
            case 9:
                return "offset-9";
            case 10:
                return "offset-10";
            case 11:
                return "offset-11";
            default:
                //return <Input addToResult={this.addToResult} formJson={item} />
                return "";
        }                
    }
    
    getClassElement(width, offset) {
        return this.getWidthClass(width) +" " + this.getOffsetClass(offset);
    }

    render() {
        let label;
        if (this.state.showLabel){
            label = <label htmlFor={this.state.id}>{this.state.text}</label>
        }  
        return (
            <div className={this.getClassElement(this.state.width, this.state.offset)} hidden={this.state.hidden ||''}>                
                {label}
                <div className={`form-group ${this.state.align === 'horizontal' ? 'kt-radio-inline' : 'kt-radio-list'}`}>
                    {this.state.values.map(item => (
                        <label key={this.getCounter()} className="kt-radio">
                            <input type="radio" 
                                key={this.getCounter()} 
                                name={this.state.id} 
                                value={this.getDataKey(item)}
                                defaultChecked={this.state.defaultValue === this.getDataKey(item)}                            
                                onChange={e => this.handleChange(this.state.id, e)}
                                />
                            {this.getDataValue(item)}
                            <span></span>
                        </label>
                    ))}
                </div>
            </div>
        );
    }
}

export default RadioForm;